import React from "react";
import {Box, Select, MenuItem, FormControl, InputLabel, SelectChangeEvent} from "@mui/material";
import {useTranslation} from "react-i18next";
import {supportedLanguages} from "../../utils/languageUtils";

const LanguageSelector: React.FC = () => {
  const {t, i18n} = useTranslation();

  const handleLanguageChange = (event: SelectChangeEvent) => {
    const newLanguage = event.target.value;
    i18n.changeLanguage(newLanguage);
    // Store the language preference in localStorage
    localStorage.setItem("preferredLanguage", newLanguage);
  };

  const getCurrentLanguageInfo = () => {
    return supportedLanguages.find((lang) => lang.code === i18n.language) || supportedLanguages[0];
  };

  const currentLang = getCurrentLanguageInfo();

  return (
    <Box sx={{minWidth: 140}}>
      <FormControl fullWidth size="small">
        <InputLabel id="language-select-label">{t("Language")}</InputLabel>
        <Select
          labelId="language-select-label"
          id="language-select"
          value={i18n.language}
          label="Language"
          onChange={handleLanguageChange}
          sx={{
            "& .MuiSelect-select": {
              display: "flex",
              alignItems: "center",
              gap: 1,
            },
          }}>
          {supportedLanguages.map((language) => (
            <MenuItem key={language.code} value={language.code}>
              <Box display="flex" alignItems="center" gap={1}>
                <span>{language.flag}</span>
                <span>{language.nativeName}</span>
                {language.code === "en" && <span style={{color: "gray", fontSize: "0.8em"}}>(US)</span>}
                {language.code === "en-IN" && <span style={{color: "gray", fontSize: "0.8em"}}>(India)</span>}
                {language.code !== "en" && language.code !== "en-IN" && <span style={{color: "gray", fontSize: "0.8em"}}>({language.name})</span>}
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default LanguageSelector;
